import config from '@/config'
import { ITrackCommunitiesAccessEvent, ITrackEvent } from '@/models/TrackEvent'
import { requests } from './HTTPService'
let http = requests(config.COMMUNITIES_SERVER_URL)

export default class AnalyticsService {
  protected basePath = ''

  constructor() {
    this.basePath = `/health`
  }

  async trackEvent(trackEvent: ITrackEvent): Promise<void> {
    await http.post(`${this.basePath}/track-event`, trackEvent)
  }

  async trackCommunitiesAccessEvent(
    trackEvent: ITrackCommunitiesAccessEvent
  ): Promise<void> {
    await http.post(
      `${this.basePath}/track-communities-access-event`,
      trackEvent
    )
  }
}
